import { render, staticRenderFns } from "./maintenrequisition.vue?vue&type=template&id=139b65dc"
import script from "./maintenrequisition.vue?vue&type=script&lang=js"
export * from "./maintenrequisition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports